<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">

      <el-row :gutter="10">
        <el-col :md="8" :lg="6">
          <el-input placeholder="手机号/订单号" v-model="mobile" size="mini"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="10" :lg="8">
            <el-date-picker v-model="timeRange" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
        </el-row>
        <el-row :gutter="10">
        <div class="btn-2"></div>
        <el-col :md="8" :lg="6">
          <el-button size="mini" type="primary" @click="exportData">导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待确认" name="0"></el-tab-pane>
        <el-tab-pane label="找药中" name="1"></el-tab-pane>
        <el-tab-pane label="结果" name="2,3"></el-tab-pane>
        <el-table :data="list" style="width: 100%" :height="wheight-200" v-loading="loading">
          <el-table-column prop="created" width="160" label="创建时间">
            <template slot-scope="scope">
              <span>{{scope.row.created | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="medicine_id" width="160" label="需求单号"></el-table-column>
          <el-table-column prop="medicine_name" label="药品名称"></el-table-column>
          <el-table-column prop="spec" label="规格"></el-table-column>
          <el-table-column prop="producer" label="生产厂商"></el-table-column>
          <el-table-column prop="num" label="数量"></el-table-column>
          <el-table-column prop="distributor" label="店铺"></el-table-column>
          <el-table-column prop="sale_mobile" label="员工电话"></el-table-column>
          <el-table-column prop="name" label="顾客"></el-table-column>
          <el-table-column prop="mobile" label="顾客手机号"></el-table-column>
          <el-table-column prop="address" label="地址"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column prop="img" label="图片">
            <template slot-scope="scope">
              <template v-for="(x,k) in scope.row.imgs">
                 <el-popover
                        placement="right"
                        width="240"
                        trigger="hover" >

                    <img  :src="x" style="width:100%;">
                    <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                </el-popover>
              </template>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 0" size="mini">待确认</el-tag>
              <el-tag v-else-if="scope.row.status == 1" type="danger" size="mini">找药中</el-tag>
              <el-tag v-else-if="scope.row.status == 2" type="success" size="mini">已找到</el-tag>
              <el-tag v-else-if="scope.row.status == 3" type="warning" size="mini">未找到</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.status==0  ">
                    <el-button size="mini" type="primary" v-if="scope.row.status == 0"  @click="dialogOpen(scope.row.id,1)">确 认</el-button>
              </div>
              <div v-if="scope.row.status==1  ">
                    <el-button size="mini" type="success"   @click="dialogOpen(scope.row.id,2)">已找到</el-button>
                    <div class="btn-2"></div>
                    <el-button size="mini" type="danger"  @click="dialogOpen(scope.row.id,3)">未找到</el-button>
              </div>
              <div>
                  <div class="btn-2"></div>
                    <el-button size="mini" type="info"  @click="dialogCancel(scope.row.id,scope.row.status)">备注</el-button>
              </div>

            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="params.page"
            :page-sizes="[10,20,50]"
            :total="total_count"
            :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </div>
    <router-view></router-view>
    <el-dialog title="备注" :visible.sync="canceldialog" :close-on-click-modal="false" width="50%">
      <section class="section section-white content-padded" onload="init()">
        <h2 class="delog-h2">状态：{{massage}}</h2>
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="回复顾客前后台可见" prop="source_video_type">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入要回复的内容"
              v-model="form.home_msg">
            </el-input>
          </el-form-item>

          <el-form-item label="新增备注进后台可见" prop="source_video_type">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注内容"
              v-model="form.admin_msg">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer content-center">
          <el-button @click.native="canceldialog = false;">取消</el-button>
          <el-button type="primary" @click="addPostMsg()">确认提交</el-button>
        </div>
      </section>
      <el-tabs type="border-card">
        <el-tab-pane label="管理员回复日志（前台只展示最新一条回复内容）" name="0"></el-tab-pane>
        <el-table :data="form_list" style="width: 100%" label="" v-loading="loadingList">
          <el-table-column prop="admin_text" label="信息:">
            <template slot-scope="scope">
              <div v-html="scope.row.home_text"></div>
            </template>
          </el-table-column>
        </el-table>

      </el-tabs>
      <el-tabs type="border-card">
        <el-tab-pane label="管理员备注日志" name="0"></el-tab-pane>
        <el-table :data="form_list" style="width: 100%" label="管理员备注日志" v-loading="loadingList">
          <el-table-column prop="admin_text" label="信息:">
            <template slot-scope="scope">
              <div v-html="scope.row.admin_text"></div>
            </template>
          </el-table-column>
        </el-table>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getFindList, getFindExport,getFindUpdate,addMsg,getMsgList } from '../../../api/trade'

  export default {
    components: {
    },
    data () {
      return {
        activeName: 0,
        loading: false,
        loadingList:false,
        canceldialog:false,
        status:0,
        massage:"",
        create_time: '',
        params: {
          page: 1,
          pageSize: 20
        },
        total_count: 0,
        list: [],
        imgs:[],
        mobile:'',
        timeRange:'',
        form:{
          home_msg:'',
          admin_msg:'',
          find_durg_id:0,
          stastu:0,
        },
        form_list:[]
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 切换tab
      handleClick(tab, event) {
        this.activeName = tab.name
        this.params.status = tab.name == 0 ? '' : tab.name
        this.params.page = 1
        console.log(this.params)
        this.getList(this.params)
      },

      numberSearch (e) {
        this.params.page = 1
        this.getParams()
        this.params.mobile = this.mobile
        this.getList(this.params)
      },

      handleCurrentChange (val) {
        this.params.page = val
        this.loading = false
        this.getParams()
        this.getList(this.params)
      },
      handleSizeChange (pageSize) {
        this.loading = false
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getParams()
        this.getList(this.params)
      },
      getParams () {

      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      getList() {
        this.loading = true
        getFindList(this.params).then(response => {
          this.list = response.data.data.list
          this.list.forEach(item => {
              item.imgs = item.img.split(",")

          })
          this.total_count = 'undefined' == typeof (response.data.data.pager) ? response.data.data.total_count : Number(response.data.data.pager.count)
          this.loading = false
        })
      },
      dialogOpen (id,val) {

          var params = {'id': id,'status':val}
          getFindUpdate(params).then(response => {
              this.$message({ type: 'success', message: '操作成功'})
              this.getList()

          })
      },
      dateChange (val) {
          if (val && val.length > 0) {
              this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_at = ''
              this.params.end_at = ''
          }
          console.log(this.params)
          this.getList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },
      addPostMsg()
      {
        this.loadingList = true
        addMsg(this.form).then(response=>{
          console.log(response.data)
          if (response.data.data.status) {
              
              this.$message({
                  type: 'success',
                  message: '添加成功'
              })
              getMsgList({status:this.form.status,find_durg_id:this.form.find_durg_id}).then(response => {
                this.form_list = response.data.data
                this.loadingList = false
                console.log(this.form_list)
              
              })
              return
          }else{
            this.$message({
                type: 'error',
                message: '添加备注失败'
            })
          }
        })
      },
      dialogCancel (detail,status) {
          this.canceldialog = true
          if(status==0)
          {
            this.massage = "待确认"
          }else if(status==1){
            this.massage = "找药中"
          }else{
            this.massage = "结果反馈"
          }
          this.form.status = status
          this.form.find_durg_id = detail
          this.loadingList = true
          getMsgList({status:this.form.status,find_durg_id:this.form.find_durg_id}).then(response => {
            this.form_list = response.data.data
            this.loadingList = false
            console.log(this.form_list)

          })
      },

      exportData() {
        
        getFindExport(this.params).then(response => {
          if (response.data.status) {
              this.$message({
                  type: 'success',
                  message: '已加入执行队列，请在设置-导出列表中下载'
              })
              return
          } else if (response.data.url) {
              this.downloadUrl = response.data.url
              this.downloadName = response.data.filename
              this.downloadView = true
          } else {
            this.$message({
                type: 'error',
                message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        })
      }
    },
    mounted () {
      this.getList()
    }
  }
</script>
<style>
    .btn-2{
       margin: 2rem;
    }
    .delog-h2{
      font-weight: bold;
      color: #5DAF34;
    }
    span.sacss {
        margin-left: 2rem;
    }
</style>



// WEBPACK FOOTER //
// finddrug.vue?3bc9436f